<div class="force-change-container">
  <nb-card accent="primary">
    <nb-card-header>Passwort ändern erforderlich</nb-card-header>
    <nb-card-body>
      <p>Aus Sicherheitsgründen musst du beim ersten Login ein neues Passwort setzen.</p>
      @if (serverError()) {
        <nb-alert status="danger" closable (close)="serverError.set('')">{{ serverError() }}</nb-alert>
      }
      <form id="forcePasswordChangeForm" [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-field">
          <label class="label" for="newPassword">Neues Passwort</label>
          <input nbInput fullWidth id="newPassword" type="password" formControlName="newPassword"
                 placeholder="Neues Passwort eingeben"
                 [status]="form.controls['newPassword'].touched && form.controls['newPassword'].hasError('minlength') ? 'danger' : 'basic'">
          @if (form.controls['newPassword'].touched && form.controls['newPassword'].hasError('minlength')) {
            <span class="validation-hint">Mindestens 8 Zeichen</span>
          }
        </div>
        <div class="form-field">
          <label class="label" for="repeatPassword">Passwort bestätigen</label>
          <input nbInput fullWidth id="repeatPassword" type="password" formControlName="repeatPassword"
                 placeholder="Neues Passwort bestätigen">
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer class="force-change-actions">
      <button nbButton status="primary" type="submit" form="forcePasswordChangeForm"
              [disabled]="form.invalid || submitting()" [nbSpinner]="submitting()">Passwort setzen</button>
      <button nbButton outline status="basic" type="button" [disabled]="submitting()"
              (click)="logout()">Abmelden</button>
    </nb-card-footer>
  </nb-card>
</div>
